export default __webpack_public_path__ + "static/5-1bc2c38074f5822da7646a9c506ba0b4.png";